/* tslint:disable */
/* eslint-disable */
/**
 * story
 * storyのAPI
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PickUpStory
 */
export interface PickUpStory {
    /**
     * 投稿のID
     * @type {number}
     * @memberof PickUpStory
     */
    id: number;
    /**
     * 投稿の記事ページハッシュ
     * @type {string}
     * @memberof PickUpStory
     */
    hash: string;
    /**
     * 企業ID
     * @type {number}
     * @memberof PickUpStory
     */
    companyId: number;
    /**
     * 投稿のタイトル
     * @type {string}
     * @memberof PickUpStory
     */
    title: string;
    /**
     * 投稿の公開ステータス
     * @type {string}
     * @memberof PickUpStory
     */
    status: string;
    /**
     * 投稿の公開ステータス(日本語)
     * @type {string}
     * @memberof PickUpStory
     */
    statusName: string;
    /**
     * 投稿のサムネイル画像URL
     * @type {string}
     * @memberof PickUpStory
     */
    thumbnailUrl: string | null;
    /**
     * 投稿のサムネイル画像URL(小)
     * @type {string}
     * @memberof PickUpStory
     */
    smallThumbnailUrl: string | null;
    /**
     * 投稿のサムネイル画像URL(極小)
     * @type {string}
     * @memberof PickUpStory
     */
    tinyThumbnailUrl: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PickUpStory
     */
    tags: Array<string>;
    /**
     * 投稿の公開日時
     * @type {string}
     * @memberof PickUpStory
     */
    postedAt: string;
}

export function PickUpStoryFromJSON(json: any): PickUpStory {
    return PickUpStoryFromJSONTyped(json, false);
}

export function PickUpStoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PickUpStory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'hash': json['hash'],
        'companyId': json['company_id'],
        'title': json['title'],
        'status': json['status'],
        'statusName': json['status_name'],
        'thumbnailUrl': json['thumbnail_url'],
        'smallThumbnailUrl': json['small_thumbnail_url'],
        'tinyThumbnailUrl': json['tiny_thumbnail_url'],
        'tags': json['tags'],
        'postedAt': json['posted_at'],
    };
}

export function PickUpStoryToJSON(value?: PickUpStory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'hash': value.hash,
        'company_id': value.companyId,
        'title': value.title,
        'status': value.status,
        'status_name': value.statusName,
        'thumbnail_url': value.thumbnailUrl,
        'small_thumbnail_url': value.smallThumbnailUrl,
        'tiny_thumbnail_url': value.tinyThumbnailUrl,
        'tags': value.tags,
        'posted_at': value.postedAt,
    };
}

